import { all, takeLatest, put } from 'redux-saga/effects';
import { SEND_ACTION, GET_DESTINATION_ACTION, SAVE_PASS_ACTION } from './constants';
import { getMessage, setDestination, addCuitAction, saveTypeCompany } from './accions';
import { setIsLoggedInAction } from '../Login/accions'
import { setReferral } from "../Callback/accions";

//const airbase = require('../../utils/airtable').base('appzL6pfzYhxOdwsg'); dev
const airbase = require('../../utils/airtable').base(process.env.airtableApiKey);

function* sendSaga(action) {
    try {
        // const pin = randomize('0', 4);

        // yield put(addPinAction(pin))

        let message = 'done';

        yield airbase.table('Clientes')
            .selectOneByFormula('Email="' + action.payload.email + '"')
            .then(function (clientRecord) {
                if (!clientRecord) {
                    airbase.table('Clientes')
                        .create({
                            'Destination': action.payload.destination,
                            'Email': action.payload.email,
                            'Step': '1',
                            'Monto': action.payload.amount,
                            'Plazo': action.payload.deadline,
                            'Tipo': action.payload.valueCheckbox,
                            'Password': action.payload.password,
                            'Referral': action.payload.referral,
                            'CUIT': action.payload.cuit,
                            'VendedorContrololador': action.payload.vendedor ? action.payload.vendedor : null
                        })
                        .then(function (response) {
                            console.log(response);
                        })
                        .catch(function (error) {
                            console.log(error);
                        })

                    return clientRecord;
                } else {
                    message = 'Ya existe un usuario con ese email.'
                }
            })

        yield put(getMessage(message))
        yield put(addCuitAction(action.payload.cuit))
        yield put(saveTypeCompany(action.payload.valueCheckbox))
        if (message === 'done') {
            yield put(setIsLoggedInAction(true))
            yield put(setReferral(action.payload.referral))
        }

    } catch (err) {
        console.log(err);
    }
}

function* destinationSaga() {
    try {
        let destinations = []

        yield airbase.table('Destino').selectAll({
            sort: [
                {
                    field: 'Orden Verdadero',
                    direction: 'asc'
                },
            ],
        }).then(function (destinos) {
            destinos.forEach((element, index) => {
                destinations.push({
                    key: index,
                    text: element.fields.Nombre,
                    value: element.fields.Nombre
                })
            })
        })

        yield put(setDestination(destinations))

    } catch (error) {
        console.log(error);
    }
}

function* watchSend() {
    yield takeLatest(SEND_ACTION, sendSaga)
}

function* watchDestination() {
    yield takeLatest(GET_DESTINATION_ACTION, destinationSaga)
}

function* saveSaga(action) {
    try {
        let message = 'done';

        yield airbase.table('Clientes')
            .selectOneByFormula('Email="' + action.payload.email + '"')
            .then(function (clientRecord) {
                if (clientRecord) {
                    clientRecord.updateFields({
                        'Password': action.payload.password,
                        'Step': '4'
                    }, function () { });
                } else {
                    message = 'No se puede guardar la contraseña.'
                }
            })

        // yield put(messageAction(message))

        if (message === 'done') {
            yield put(setIsLoggedInAction(true))
        }

    } catch (err) {
        console.log(err);
    }
}
function* watchSave() {
    yield takeLatest(SAVE_PASS_ACTION, saveSaga)
}

export default function* step1Saga() {
    yield all([
        watchSend(),
        watchDestination(),
        watchSave()
    ]);
}



// WEBPACK FOOTER //
// ./src/conteiners/Step1/sagas.js